<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.08 10.13a5 5 0 001.35-.63L20.68 8H22V6h-1.32a2 2 0 00-1.11.34l-2.25 1.49a2.73 2.73 0 01-.81.38L13.72 9a1 1 0 00-.72 1v3.5a1 1 0 00.86 1l2.29.33a2.49 2.49 0 004.64.18H22V13h-1.21a2.49 2.49 0 00-4.48-.18L15 12.63v-1.88zM5.5 16.5A2.51 2.51 0 007.79 15H10a1 1 0 001-1v-4a1 1 0 00-.82-1l-3.74-.69-2.28-1.86A2 2 0 002.89 6H2v2h.89l2.48 2a.94.94 0 00.45.21l3.18.6V13H7.79a2.5 2.5 0 00-4.58 0H2v2h1.21a2.51 2.51 0 002.29 1.5zM21 18H3a1 1 0 000 2h18a1 1 0 000-2z"/></svg>